/**
 * Import lib & config
 */

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import t from 'theme';

/**
 * Import components
 */

/**
 * styled components
 */

const Title = styled.h1`
  color: ${(props) => props.color || t.color.black};
  margin: 0 0 ${t.grid.space2} 0;
  font-weight: ${
    t.font.regular};
  font-family: ${t.font.secondary};
  ${t.mixins.rem(30, 34)}
  ${t.mixins.flex()};
  ${t.mixins.bg()};
  ${t.mixins.fit()};
  ${t.mixins.sm(`
    ${t.mixins.rem(30, 30)}
  `)}
`;

/**
 * A text components
 */

const Content__title = ({ style, children, color }) => (
  <Title style={style} color={color}>{children}</Title>
);


Content__title.propTypes = {
  /**
    A custom style object
    */
  children: PropTypes.string,
  /**
    A children object to render content inside the components
    */
  color: PropTypes.string,

  /**
    A children object to render content inside the components
    */
  style: PropTypes.object,
};

Content__title.defaultProps = {
  style: {},
  children: null,
  color: t.color.black,
};

export default Content__title;
